import { CRMPlatform } from "@/enums/CRM.enum";
import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type CreateCRMConnection = {
  platform: CRMPlatform;
  listId?: string;
};

export const useCRMConnect = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: ({ listId }: CreateCRMConnection) => apiClient.crmConnectionsHubspot.connect({ listId }),
    onSuccess: (data) => {
      const url = new URL(data.url);
      window.location.assign(url.href);
    },
  });

  return {
    ...mutation,
    connectCRM: mutation.mutate,
    connectCRMAsync: mutation.mutateAsync,
  };
};
